<template>
    <section class="student">
        <div v-if="student">
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <h1>
                    {{student.first}} {{student.last}} 
                    </h1>
                    <h4><a :href="'mailto:' + student.email">{{student.email}}</a></h4>
                    <h4 class="galleries-link"><router-link :to="{ name: 'galleries', query: { author: userId } }">Gallery Submissions</router-link></h4>
                </div>
                <div class="col-sm-12 col-md-6 text-right">
                    <img v-bind:src="student.avatar">
                </div>
            </div>
            <div v-if="!localStorage.roles.includes('CampusDirector')">
                <div class="panel status row">
                    <div class="panel-heading" @click="showStatus = !showStatus">
                        <h2>Status 
                            <i v-if="showStatus" class="fa fa-caret-down"></i>
                            <i v-else class="fa fa-caret-right"></i>
                        </h2>
                    </div>
                    <div v-if="showStatus && currentTerm">
                        <status :userId="userId" :currentTerm="currentTerm"></status>
                    </div>
                </div>
                
                <div v-if="!localStorage.roles.includes('OnlineDirector')" class="panel videos row">
                    <div class="panel-heading" @click="showProgresses = !showProgresses">
                        <h2>Video Progress 
                            <i v-if="showProgresses" class="fa fa-caret-down"></i>
                            <i v-else class="fa fa-caret-right"></i>
                        </h2>
                    </div>
                    <ul class="list-group" v-if="showProgresses">
                        <li v-for="video in videos" class="list-group-item">
                            <h3>{{video.title}}</h3>
                            <ul class="list-group row progresses">
                                <li v-for="chapter in video.video_chapters" class="col-xs-12">
                                    <div class="col-xs-4">
                                        <h4>{{chapter.title}}</h4>
                                    </div>
                                    <div class="progress-wrapper col-xs-8">
                                        <span class="progress" v-if="chapter.progress" v-bind:style="{ width: progress(chapter) + '%' }">{{progress(chapter)}}%</span>
                                    </div>

                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div v-if="!localStorage.roles.includes('OnlineDirector')" class="panel interactions row">
                    <div class="panel-heading" @click="showInteractions = !showInteractions">
                        <h2>Interactions
                            <i v-if="showInteractions" class="fa fa-caret-down"></i>
                            <i v-else class="fa fa-caret-right"></i>
                        </h2>
                    </div>
                    <div class="panel-body" v-if="showInteractions">
                        <div class="col-lg-4 col-md-3 text-center">
                            <div class="badge">{{student.posts}}</div>
                            <h4>Posts</h4>                   
                        </div>  
                        <div class="col-lg-4 col-md-3 text-center">
                            <div class="badge">{{student.chatMessages}}</div>
                            <h4>Chat Messages</h4>
                        </div> 
                        <div class="col-lg-4 col-md-3 text-center">
                            <div class="badge">{{student.assignments.length}}</div>
                            <h4>Hand-ins</h4>
                        </div>
                         
                    </div>
                </div>
                <div v-if="!localStorage.roles.includes('OnlineDirector')" class="panel assignments panel-primary">
                    <div class="panel-heading exercises-header" @click="showExercises = !showExercises">
                        <h2>
                            <img src="../assets/img/exercise-icon.png">Exercises
                            <i v-if="showExercises" class="fa fa-caret-down"></i>
                            <i v-else class="fa fa-caret-right"></i>
                        </h2>
                    </div>
                    <div class="panel-body nopad" v-if="showExercises">
                        <table class="table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>Course</th>
                                    <th>Exercise</th>
                                    <th>Week</th>
                                    <th>Self-Assessment</th>
                                    <th>Comments</th>
                                    <th>Files</th>
                                    <th>Submitted On</th>
                                </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="handin in student.handins" :class="{'danger': handin.assessment == 1}">
                                    <td>{{handin.exercise.associated.name}}</td>                               
                                    <td><span v-if="handin.exercise && handin.exercise.title">{{handin.exercise.title}}</span></td>
                                    <td>{{handin.week}}</td>
                                    <td><span v-if="handin.assessment">{{getAssessment(handin.assessment)}}</span></td>
                                    <td><span v-if="handin.comments">{{handin.comments}}</span></td>
                                    <td><div v-for="(file, $index) in handin.url"><a target="_blank" :href="file">File {{$index + 1}}</a></div></td>
                                    <td>{{handin.createdAt | longDate}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div v-if="!localStorage.roles.includes('OnlineDirector')" class="panel assignments panel-primary">
                    <div class="panel-heading assignments-header"  @click="showAssignments = !showAssignments">
                        <h2>
                            <img src="../assets/img/assignment-icon.png">Assignments
                            <i v-if="showAssignments" class="fa fa-caret-down"></i>
                            <i v-else class="fa fa-caret-right"></i>
                        </h2>
                    </div>
                    <div class="panel-body nopad" v-if="showAssignments">
                        <table class="table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>Course</th>
                                    <th>Assignment</th>
                                    <th>Week</th>
                                    <th>Submitted On</th>
                                    <th>Grade</th>
                                    <th>Submission</th>
                                </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="assignment in student.assignments">                                   
                                        <td>{{assignment['instance.associated.name']}}</td>
                                        <td>{{assignment['assignment.name']}}</td>
                                        <td>{{assignment['assignment.week']}}</td>
                                        <td>{{assignment.createdAt | shortDate}}</td>
                                        <td>{{assignment.grade}}</td>
                                        <td><a @click.prevent="openAssignment(assignment.url, assignment['assignment.name'])" class="btn btn-sm btn-success">Download</a></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="panel evaluations row">
                        <div class="panel-heading" @click="showEvaluations = !showEvaluations">
                            <h2>Evaluations
                                <i v-if="showEvaluations" class="fa fa-caret-down"></i>
                                <i v-else class="fa fa-caret-right"></i>
                            </h2>
                        </div>
                        <div class="panel-body" v-if="showEvaluations">
                           <div v-for="evaluation in evaluations" class="col-sm-6">
                            <h4>{{evaluation.term | capitalize}}</h4>
                            <div class="form-group">
                                <textarea class="form-control" rows="5" v-model="evaluation.comments"></textarea>
                            </div>
                            <div class="form-group">
                                <button @click.prevent="saveEvaluation(evaluation)" class="btn btn-success">Save</button>
                            </div>
                           </div>


                        </div>
                    </div>

                </div>
            </div>

            <div class="panel projects row" v-if="canSeeFinalProjects">
                <div class="panel-heading" @click="showProjects = !showProjects">
                    <h2>
                        Final Projects
                        <i v-if="showProjects" class="fa fa-caret-down"></i>
                        <i v-else class="fa fa-caret-right"></i>
                    </h2>
                </div>
                <div v-if="showProjects" class="project panel-body">
                    <ul v-if="student && student.final_projects" class="projects">
                        <li v-for="(project, $index) in student.final_projects">
                           
                            <div class="table-row">
                                <div><i @click.prevent="selectedProject===project.id?selectedProject=null:selectedProject=project.id" class="fa fa-plus"></i></div>
                                <div>{{project.createdAt | shortDate}}</div>
                                <div>       
                           
                                    <div v-for="(final_feedback, $feedbackIndex) in project.final_feedbacks">
                                        <img v-if="final_feedback && final_feedback.url.trim() != ''" 
                                        class="play-button" 
                                        @click="playFeedback(final_feedback.url)"
                                        src="../assets/img/play-button-small-green.png">
                                        <span v-else>
                                            <img v-if="$feedbackIndex === 0" class="play-button" src="../assets/img/play-button-small-grey.png">
                                        </span>
                                    </div>

                                </div>
                                <div class="project-status" :class="getStatus(project)">
                                    {{getStatus(project) | deslugify}}
                                </div>
                            </div>
                            <div v-if="selectedProject===project.id" class="project">
                                <div class="media">
                                    <div class="project-images text-center">
                                       
                                        <div class="reel text-center">
                                            <video controls>
                                                <source :src="project.demoReelUrl.replace('drive.google.com:','')">
                                            </video>
                                            <a :href="project.demoReelUrl.replace('drive.google.com:','')" target="_blank">
                                                Download
                                            </a>                                        
                                        </div>

                                        
                                    </div>
                                    <div class="still-renders">
                                        <ul class="still-renders" v-if="project.stillRenders && project.stillRenders.length > 0">
                                            <li v-for="(render, $index) in project.stillRenders">
                                                <div v-if="render.includes('amazonaws')">
                                                    <a :href="render" target="_blank">
                                                        Image {{$index + 1}}
                                                    </a>
                                                </div>
                                                <div v-else>
                                                    <a class="possibly-broken-image" :href="'https://drive.google.com/uc?download=view&id=' + render.replace('drive.google.com:','')" target="_blank">
                                                        Image {{$index + 1}}
                                                    </a>
                                                </div>
                                            </li>
                                            <li><h4 class="bold">Additional Videos</h4></li>
                                            <li v-if="project.extraVideos.length === 0">No additional videos</li>
                                            <li v-for="(asset, $index) in project.extraVideos">
                                                <a :href="asset.url" target="_blank">{{asset.descriptor}}</a>                                        
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div v-if="project.comments"><label class="comments">Student Comments</label><div class="comments" v-html="$options.filters.linkify(escapeHtml(project.comments))"></div></div>
                                
                                <div class="diploma" v-if="project.passed === true && student.venue !== 'Campus'">
                                    <a :href="'https://ttto-graduation-certificates.s3.us-west-2.amazonaws.com/Think_Tank_Graduation_Certificate_'+student.populiId+'.pdf'" _target="blank">
                                        Digital Diploma
                                    </a>
                                    <div>
                                    <p>If you would like a hard copy mailed to you, please email <a href="mailto:online@tttc.ca">online@tttc.ca</a> with your current address<br>*Mailing a hard copy may require processing fees</p>
                                    </div>
                                </div>
                                
                                <div v-for="final_feedback in project.final_feedbacks">
                                    <div class="director-comments" v-if="final_feedback.comments">
                                        <label class="comments">{{final_feedback.author.firstName}} {{final_feedback.author.lastName}}'s Comments ({{final_feedback.createdAt | checkinDate}})</label>
                                        <button v-if="final_feedback.author.id == localStorage.user_id && isDirector" @click.prevent="deleteFeedback(final_feedback.id)" class="btn btn-xs delete">Delete Comments and Video</button>
                                        <div class="comments">{{final_feedback.comments}}</div>
                                    </div>
                                </div>
                                
                                <label class="comments">Director's Comments</label>
                                <div class="submit-feedback">
                                    <div class="stack" style="flex-grow: 4">
                                    <textarea class="form-control" v-model="project.feedbackComments"></textarea>
                                    <div v-if="$index == student.final_projects.length - 1">
                                            <label v-if="getStatus(project) == 'feedback_required'">
                                                <input type="checkbox" :checked="project.ignores == 1 || project.ignores == 3" @change="ignoreFeedback(project)">
                                                Ignore in Feedback Count
                                            </label>
                                            <label style="margin-left: 2rem;" v-if="!project.cloudinaryIds && getStatus(project) == 'passed'">
                                                <input type="checkbox" :checked="project.ignores == 2 || project.ignores == 3" @change="ignoreCloud(project)">
                                                Ignore in Cloudinary Count
                                            </label>
                                        </div>
                                    </div>
                                
                                    <div class="stack">
                                        <label for="upload-feedback" class="upload-feedback">
                                            Place Feedback Video (MP4)
                                            <input ref="feedbackVideo" type="file" id="upload-feedback" accept="video/mp4">
                                        </label>
                                        
                                        <div class="stack start">
                                            <label>
                                                <input type="checkbox" :checked="!project.passed" name="passed" :disabled="disablePassCheckboxes" @change="project.passed=false">
                                                Fixes Required
                                            </label>
                                            <label>
                                                <input type="checkbox" :checked="project.passed" name="passed" :disabled="disablePassCheckboxes" @change="project.passed=true">
                                                Mark as Passed
                                            </label>
                                        </div>
                                    </div>

                                    <div class="stack">
                                        <button class="btn btn-success btn-blue" @click.prevent="createFeedback(project.id)">Submit Feedback</button>

                                        <button class="btn btn-success btn-blue" v-if="inCloud(project) && (isLatestProject($index) || !inCloud(student.final_projects[$index+1]))">
                                            <a target="_blank" :href="searchUrl(project.cloudinaryIds)">
                                                View in Cloudinary
                                            </a>
                                        </button>                                 
                                        <button v-else-if="$index == student.final_projects.length - 1" class="btn btn-success btn-blue" @click.prevent="sendToCloudinary()">
                                            Upload Project to Cloudinary
                                        </button>
                                    </div>                              
                                </div>
                            </div>
                        </li>
                    </ul>
            </div>
        </div>

        <div class="feedback-lightbox" @click="stopFeedback()" v-show="feedbackPlaying===true">
            <i class="fa fa-remove"></i>
            <div class="video-wrapper" @click.stop>
                <video-player ref="videoPlayer" v-show="feedbackPlaying" :options="playerOptions">
                </video-player>
            </div>
        </div>
    </section>
</template>


<script>
    import students from '../services/students';
    import finalProjects from '../services/final-projects';
    import aws from '../services/aws';
    import terms from '../services/terms';
    import cloudinary from '../services/cloudinary';
    import axios from "axios";

    import Status from './Status';

    import jszip from 'jszip';
    import JSZipUtils from 'jszip-utils';
    import FileSaver from '../../node_modules/file-saver/dist/FileSaver.js';
    import { videoPlayer } from 'vue-video-player';
    import toastr from 'toastr';
          
    const uuidV4 = require('uuid/v4');  

    export default {
        data() {
            return {
                student: null,
                showStatus: true,
                showProgresses: false,
                showInteractions: false,
                showExercises:false,
                showAssignments:false,
                showEvaluations: false,
                showProjects: false,
                selectedProject: null,
                feedbackProject:null,
                term:null,
                feedback: {comments:null},
                evaluations: [{term: 'foundation',comments:null},{term: 'intermediate',comments:null},{term: 'advanced',comments:null},{term: 'mentorship',comments:null}],
                assessments: ['I\'m completely lost','I think I got it', 'I nailed it'],
                feedbackPlaying: false,
                uploading: false,
                disablePassCheckboxes:false,
                playerOptions: {
                    start: 0,
                    controls: true,
                    preload: 'auto',
                    autoplay: false,
                    fluid: true,
                    sources: []
                },
                statuses: null              
            }
        },
        components: {
            'video-player': videoPlayer,
            'status': Status
        },
        async mounted() {

            this.term = this.$route.query.term;
            this.currentTerm = await terms.getTerm(this.term);
            this.studentId = this.$route.params.studentId;
            this.userId = this.$route.query.userId;
            this.getStudentInfo(this.studentId);
            if (this.$route.query.open === 'projects') this.showProjects = true;

            if(this.$route.query.selectedProject){
                this.selectedProject = parseInt(this.$route.query.selectedProject)
                this.showProjects = true
                this.showStatus = false
            }
            this.$nextTick(()=> {
                this.fixBrokenImages();
            });
        },
        updated() {
            this.$nextTick(()=> {
                this.fixBrokenImages();
            });

        },
        methods: {
            escapeHtml(text) {
                text = text || '';
                text = text.replace(/&/g, '&amp;');
                text = text.replace(/</g, '&lt;');
                text = text.replace(/>/g, '&gt;');
                text = text.replace(/"/g, '&quot;');
                return text;
            },
            sendToCloudinary() {
                this.$store.dispatch('toggle', { type: 'loading', boolean: true });

                const latestSubmission = this.student.final_projects[this.student.final_projects.length - 1];
                // let latestSubmission = project
                // console.log(project.id)
                cloudinary.sendToCloudinary({projectId: latestSubmission.id, userId: latestSubmission.userId}).then((response)=>{
                    response.data.success === true ? toastr.success('Success!') : toastr.error('Error sending to Cloudinary');

                    this.$store.dispatch('toggle', { type: 'loading', boolean: false });

                    this.getStudentInfo(this.studentId);

                });
            },
            fixBrokenImages() {
                let possiblyBroken = document.querySelectorAll('.possibly-broken-image');
                
                for (let link of possiblyBroken) {
                    let img = new Image();
                    img.onerror = function() {
                        link.innerHTML = 'Download';
                        link.className += " broken";
                    }
                    img.src = link.children[0].src;
                }

            },

            deleteFeedback(feedbackId) {
                const yes = confirm('Are you sure?');

                if (!yes) return;
                
                finalProjects.deleteFeedback(feedbackId).then((response)=> {
                    response.data.success === true ? this.getStudentInfo(this.studentId) : toastr.error('Error deleting feedback');
                });
            },

            getStatus(project) {
                if (project.passed === true) {
                    return 'passed';
                } 
                if ((!project.final_feedback && !project.final_feedbacks) || project.final_feedbacks.length === 0) {
                    return 'feedback_required';
                } 
                return 'fixes_required';
            },
            stopFeedback() {
                this.$refs.videoPlayer.player.pause();
                this.feedbackPlaying = false;
            },
            playFeedback(url) {
                var self = this;
                var filename = url.split('/').pop();

                self.playerOptions.sources = [];

                self.$store.dispatch('toggle', { type: 'loading', boolean: true });

                aws.getPresignedUrl(self, 'ttto-final-feedback', filename, 'getObject', false, 'finalFeedback').then(function(presigned) {
                    self.$store.dispatch('toggle', { type: 'loading', boolean: false });

                    self.playerOptions.sources.push({
                        src: presigned.data,
                        type: 'video/mp4'
                    });
                    self.feedbackPlaying = true;

                }).catch(function(error) {
                    self.$store.dispatch('toggle', { type: 'loading', boolean: false });
                    toastr.error('Error getting feedback video');
                });

            },
            saveEvaluation(evaluation) {
                
                evaluation.userId = this.student.tttoId;

                students.evaluate(this, evaluation).then(function(response) {
                    response.data.success === true ? toastr.success('Updated') : toastr.error('Error updating');                
                });
            },
            getAssessment(assessment) {
                return this.assessments[assessment - 1];
            },
            openAssignment(urls, name) {
                var zip = new jszip();
                var count = urls.length;
                var studentName =  this.student.first + ' ' + this.student.last;
                urls.forEach(function(url,index) {

                    let filename;
                    
                    if (url.includes('s3-accelerate')) {
                        filename = url.split('s3-accelerate.amazonaws.com/')[1].replace(/\+/g, ' ');
                    } else {
                        filename = url.split('submissions/')[1]
                    }

                    aws.getPresignedUrl(this, 'ttto-assignment-submissions', filename, 'getObject', false,'submissions').then(function(response) {
                        JSZipUtils.getBinaryContent(response.data, function(err, data) {
                            if (err) console.log(err);
                            zip.file(filename, data, { binary:true });
                            if ((index + 1) === count) {
                                zip.generateAsync({
                                    type: "blob"
                                })
                                .then(function(content) {                                    
                                    FileSaver.saveAs(content, studentName + ' - ' + name + '.zip');
                                });
                            } 
                        });
                    });  
                });
            
            },
            getStudentInfo() {
                var self = this;
                students.getInfo(this, this.studentId, this.term).then(function(response) {
                    self.student = response.data.response;

                    if (self.student.final_projects) {
                        self.student.final_projects = self.student.final_projects
                        .map(function(p) { p.feedbackComments = null, p.feedbackUrl = null; return p; })
                        .sort(function(a,b) {return new Date(a.createdAt) - new Date(b.createdAt)})
                        .map((p)=>{
                            if (!p.assetImages) {
                                p.assetImages = [];
                            }

                            p.extraVideos = p.assetImages.filter((a) => { 
                                return a.url && a.url.includes('.mp4') && a.url !== p.demoReelUrl;
                            });
                            
                            return p;
                        });
                        // const alreadyPassed = self.student.final_projects.find((p)=> { return p.passed === true });
                        // if (alreadyPassed) {
                        //     self.disablePassCheckboxes = true;
                        // }
                    }
                    if (self.student.evaluations) {
                        self.student.evaluations.forEach(function(e) {
                            let term = self.evaluations.findIndex(function(t) { return t.term === e.term});
                            self.evaluations[term].comments = e.comments;
                        })
                    }

                });
                
                
            },
            progress(chapter) {
                if (chapter && chapter.progress) {
                    var progress =  ( ( (Math.round(chapter.progress.progress) / chapter.duration) * 100).toFixed(2) );
                    if (progress > 100) progress = 100;
                    return progress;
                }
            },
            async setStatus(id, event) {
                var self = this;           

                let passed = JSON.parse(event.target.value);

                if (passed === true) {

                    for (let project of this.student.final_projects) {
                        if (project.final_feedback && project.id !== id && project.final_feedback.passed === true) {
                            await finalProjects.updateFeedback({id: project.id, passed: false});
                        }
                    }
                }
                finalProjects.updateFeedback({id: id, passed: passed}).then(function(response) {
                    response.data.success === true ? self.getStudentInfo() : toastr.error('Error changing feedback');
                });
                
            },

            uploadFeedback(file, id) {
                var self = this;

                self.uploading = true;               

                let project = this.student.final_projects.find(function(p) { return p.id === id});

                const filename = uuidV4() + '.' + file.name.split('.').pop();
           
                return new Promise(function(resolve, reject) {
                    aws.signature(file, filename, 'ttto-final-feedback').then(function(signature) {
                         aws.getPresignedUrl(self, 'ttto-final-feedback', filename, 'putObject').then(function(presignedUrl) {
                            aws.upload(file, filename, signature, 'ttto-final-feedback', presignedUrl.data).then(function(response) {                                  
                                self.uploading = false;
                                resolve(response.url);                                
                            }).catch(function(error) {
                                console.log(error);   
                                self.uploading = false; 
                                toastr.error('Error adding video');  
                                reject();                      
                            });
                        });
                    });   
                })

            },

            async createFeedback(id) {
                var self = this;

                if (self.uploading === true) {
                    toastr.error('Please wait until your video is finished uploading');
                    return false;
                }

                let url = ' ';

                let files = self.$refs.feedbackVideo[0].files;
             
                if (files.length === 0) {
                    var confirm = window.confirm('You are adding feedback without a video. Do you want to do this?');
                    if (confirm === false) {
                        return;
                    }
                }
                else {
                    url = await self.uploadFeedback(files[0], id);
                }
 

                let project = this.student.final_projects.find(function(p) { return p.id === id});
             
                let feedback = {
                    finalProjectId: project.id,
                    comments: project.feedbackComments,
                    passed: project.passed || false,
                    url: url
                }

                finalProjects.createFeedback(feedback).then(function(response) {
                    if (response.data.success === true) {
                        toastr.success('Feedback added');
                        self.getStudentInfo()
                    } else {
                        toastr.error('Error adding feedback');
                    }
                }); 
            },
            searchUrl(ids){
                let s = "https://cloudinary.com/console/c-492af8efd06dc4929371564cc3ba67/media_library/search?q=%7B%22userQuery%22%3A%5B"
                for(let i=0; i< ids.length; i++){
                    s += '"' +ids[i].split("/").at(-1) +'"'
                    if(i != ids.length-1) 
                        s += "%2C"
                }
                s += "%5D%7D"
                return s
            },
            ignoreFeedback(project){
                let changes = [1,0,3,2]
                project.ignores = changes[project.ignores]
                
                this.setIgnore(project)
            },
            ignoreCloud(project){
                let changes = [2,3,0,1]
                project.ignores = changes[project.ignores]
                
                this.setIgnore(project)
            },
            setIgnore(project){
                // if (project.ignores )
                var options = {
                    url: window.apiUrl + "/final-projects/setIgnore",
                    headers: { Authorization: "Bearer " + localStorage.token },
                    method: "POST",
                    data: { id: project.id, ignores: project.ignores },
                };
                return axios.request(options).then(function (response) {
                    console.log(response)
                    return response.data;
                });
            },
            inCloud(project){
                return project.cloudinaryIds && project.cloudinaryIds.length > 0
            },
            isLatestProject(index){
                return index == this.student.final_projects.length - 1
            }
        },
        computed: {
            isDirector() {
                const roles = JSON.parse(localStorage.roles);
                return roles.includes('OnlineDirector') || roles.includes('CampusDirector') || roles.includes('Admin');
            },
            canSeeFinalProjects() {
                const roles = JSON.parse(localStorage.roles);
                return roles.includes('Admin') || roles.includes('CampusDirector') || roles.includes('OnlineDirector') || roles.includes('OnlineReelReviewer');
            },
            videos() {
                var self = this;
                if (self.student) {
                    var videos = self.student.videos;
                    var progresses = self.student.progresses;
                    progresses.forEach(function(progress) {
                        var videoIndex = videos.findIndex(function(x) { return x.id === progress.videoId});
                        if (videoIndex > -1) {
                            var chapterIndex = videos[videoIndex].video_chapters.findIndex(function(y) { return y.id === progress.chapterId});
                            if (chapterIndex > -1) {
                                videos[videoIndex].video_chapters[chapterIndex].progress = progress;
                            }
                        }
                        
                    });
                    return videos;
                }
            }
        }
    }
    
</script>

<style lang="scss">
    section.status {
        color:#b0b0b0;
    }
</style>
<style scoped lang="scss">

button.delete {
    background: red;
    color:#fff;
    margin-left: 1rem;
}
h1 {
    span {
    display:block;
    font-size: 2rem;
    margin-top:2rem;
    }
}
.panel-heading {
    cursor: pointer;
}
.panel {
    margin-bottom:0;
}

.progresses {
    margin:0 -1rem;
    padding:0;
    h4 {
        margin:0;
        font-size:1.4rem;
        padding-top:8px;
    }
    li {
       height:2rem;
    }
}
.progress {
    display:inline-block;
    height:10px;
    background: #42b983;
    margin-top:10px;
    text-align: center;
    color: #fff;
    font-size: .85rem;
    border-radius:0;
}
.interactions {

   .badge {
    font-size:2rem;
    margin-top:2rem;
    padding:2rem;
   }
}

.assignments-header {
    h2 img {
        margin-right:1rem;
    }
}

.exercises-header {
    h2 img {
        margin-right:1rem;
    }
}

.panel-primary > .panel-heading {
    border:none;
}

.evaluations .panel-body {
    padding-bottom:2rem;
}

    .projects li:last-child .table-row {
        border-bottom: 1px solid #b0b0b0;
    }

    .table-row {
        display:flex;
        border:1px solid #b0b0b0;
        border-bottom:none;
        i {
            cursor: pointer;
        }
        .play {
            width:30px;
            height:30px;
        }
        & > div {
            min-height:100%;
            padding:5px;
            border-right:1px solid #b0b0b0;
            display:flex;
            justify-content:flex-start;
            align-items:center;
        }
        & > div:first-child {
           width:4%;
           text-align:center;
           display:flex;           
           justify-content:center;
           i {
            cursor:pointer;
           }
        }
        & > div:nth-child(2) {
            width:63%;
        }
        & > div:nth-child(3) {
            min-width:25%;
            display:flex;
            justify-content:center;
        }       
        & > div:nth-child(4) {
            width:24%;
            border-right:none;
        }
    }
    .media {
        display:flex;        
    }
    .project-images {
        border-top:1px solid #b0b0b0;
        padding-top:2rem;
        margin-bottom:2rem;
        display:flex;
        width:70%;
        
        & > div {
            padding:1rem;
        }
      
    }
    div.still-renders {
        width:30%;
        border-top:1px solid #b0b0b0;
        padding-top:2.5rem;
    }
    .thumbnail a.broken, .reel a {
        border:1px solid #3cf;
        padding:.5rem 1rem;
        border-radius:3px;
    }
    .reel {
        width:100%;
        video {
            width:100%;
        }
    }
    .reel a {
        display: block;
        margin-top:1rem;

    }
    #upload-feedback {
        display:none;
    }

    .comments {
        padding:1rem;
    }

    .play-button {
        width:30px;
        height:30px;
        cursor:pointer;
        object-fit: contain;
    }

    .project-status {
        color:#1a1a1a;
        &.passed {
            background:#3AC384;
        }
        &.feedback_required {
            background:#C33B3A;
        }
        &.fixes_required {
            background:#3AB8C4;
        }

    }

    label.comments {
        display:block;
        font-weight:700!important;
        padding-bottom:0;
    }

    .submit-feedback {
        display:flex;
        align-items: center;
        padding-bottom:2rem;

        .upload-feedback {
            padding: 1rem;
            margin-bottom: 2rem;
        }
        textarea {
            border:none!important;
            background:#1C1C1C!important;
            height:15rem!important;
            width:100%; 
            resize:none;
            margin:1rem;
            margin-top: 0;
        }
        
        label[for=upload-feedback] {
            border:1px solid #b0b0b0;
            background:#1C1C1C!important;
            text-align:center;
            padding:5px;
            color:#b0b0b0;
            cursor: pointer;
        }

        .stack {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            flex-grow: 1;
            margin-left: 1rem;
            margin-right: 1rem;

            &.start {
                align-items: flex-start;
            }
        }
        button {
            background:#1c1c1c;
            color: #b0b0b0;
            border: 1px solid #b0b0b0;
            border-radius:1px;
            padding:5px 10px;
            margin-top:2rem;

            &.btn-blue{
                border:1px solid #3cf;
                color: #3cf;

                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }
    .director-comments {
        padding-bottom:30px;
        .comments {
            white-space: pre-wrap;
            word-break: break-word;

        }
    }
    .diploma {
        padding:1rem;
        p {
            margin-top:1rem;
        }
    }
    .galleries-link {
        line-height: 40px;
    }
</style>




// WEBPACK FOOTER //
// Student.vue?30614440